module.exports = __webpack_public_path__ + "img/palestinestate.45ed039b.svg";